import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Button } from '@outdoor-voices/ui';
import { useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import PropTypes from 'prop-types';
import css from './VideoTitle.module.scss';
import { CDN, VIDEO_PROPS, VIDEO_TRACK } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var VideoTitle = function VideoTitle(_ref) {
  var copy = _ref.copy,
      isMobile = _ref.isMobile,
      name = _ref.name,
      url = _ref.url,
      video = _ref.video;

  var _useInView = useInView({
    triggerOnce: true
  }),
      _useInView2 = _slicedToArray(_useInView, 2),
      ref = _useInView2[0],
      inView = _useInView2[1];

  var _useInView3 = useInView(),
      _useInView4 = _slicedToArray(_useInView3, 2),
      videoRef = _useInView4[0],
      videoInView = _useInView4[1];

  var videoWrapRef = useRef(null);
  useEffect(function () {
    var current = videoWrapRef.current;
    var videoEl = current.querySelector('video');

    if (!videoEl) {
      return;
    }

    if (videoInView) {
      try {
        videoEl.play();
      } catch (exc) {
        console.info('play error', exc);
      }
    } else {
      try {
        videoEl.pause();
      } catch (exc) {
        console.info('pause error', exc);
      }
    }
  }, [videoInView]);
  var src = isMobile ? "".concat(CDN).concat(video.srcMobile) : "".concat(CDN).concat(video.src);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: css.video,
      ref: ref,
      children: /*#__PURE__*/_jsx("div", {
        ref: videoWrapRef,
        children: inView && /*#__PURE__*/_jsxs("video", _objectSpread(_objectSpread({}, VIDEO_PROPS), {}, {
          ref: videoRef,
          children: [/*#__PURE__*/_jsx("source", {
            src: src,
            type: "video/mp4"
          }), /*#__PURE__*/_jsx("track", {
            kind: "subtitles",
            label: "english_subtitles",
            src: VIDEO_TRACK,
            srcLang: "en"
          })]
        }))
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: css.text,
      children: [/*#__PURE__*/_jsx("h2", {
        className: css.title,
        dangerouslySetInnerHTML: {
          __html: name
        }
      }), /*#__PURE__*/_jsx("p", {
        className: css.copy,
        dangerouslySetInnerHTML: {
          __html: copy
        }
      }), /*#__PURE__*/_jsx("div", {
        className: css.button,
        children: /*#__PURE__*/_jsxs(Button, {
          ariaLabel: "Click to view ".concat(name, ". Link opens in new tab."),
          big: true,
          href: url,
          targetBlank: true,
          children: ["Shop \u2014 ", name]
        })
      })]
    })]
  });
};

VideoTitle.propTypes = {
  copy: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  video: PropTypes.shape({
    src: PropTypes.string,
    srcMobile: PropTypes.string
  }).isRequired
};
export default VideoTitle;